export class HeaderMove {
  constructor() {
    this.$header = document.querySelector('.js-header');
    this.beforePos = 0;
    this._event();
  }

  _removeClass() {
    this.$header.classList.remove('is-active');
  }

  _addClass() {
    this.$header.classList.add('is-active');
  }

  _event() {
    window.addEventListener('scroll', () => {
      let scrollPos = window.scrollY;

      if (scrollPos > this.beforePos) {
        this._removeClass();
      } else if (scrollPos < this.beforePos) {
        this._addClass();
      }

      this.beforePos = scrollPos;
    });
  }
}
